import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from "react-redux";
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import AdminChatIcon from 'web/assets/images/AdminChatIcon.png';
import CloseIconWhite from 'web/assets/images/CloseIconWhite.png';
import ChatUserIcon from 'web/assets/svg/ChatUserIcon';
import { getUnreadCountApi, msgReadAllApi } from "redux/actions/myOrders";
import ChatSendIcon from 'web/assets/images/ChatSendIcon.png';
import * as moment from 'moment';

const ChatBlock = (props) => {
    const orderDetails = props.orderDetails;
    const isAccordionOpen = props.isAccordionOpen
    const chatBottomStackedOrders = props.chatBottomStackedOrders
    const chatWindowRef = useRef(null);
    const token = localStorage.getItem("token");
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(true)
    const [openChatBoxState, setOpenChatBoxState] = useState(false);
    const [messageText, setMessageText] = useState('');
    const [stompClient, setStompClient] = useState(null);
    const [messages, setMessages] = useState([]);
    const [unreadMsgCount, setUnreadMsgCount] = useState(0);
    const [screenSize, setScreenSize] = useState()

    useEffect(() => {
        setScreenSize(window?.innerWidth)
        if (isAccordionOpen) props.setChatBottomStackedOrders('subtract', orderDetails?.id)
        if (isAccordionOpen && window?.innerWidth > 1024) {
            // setOpenChatBoxState(true)
            props.setChatBottomStackedOrders('subtract', orderDetails?.id)
        } else {
            if (stompClient) {
                setStompClient(null)
                stompClient.disconnect();
            }
            setOpenChatBoxState(false)
            setLoader(true)
            setMessages([])
        }
    }, [isAccordionOpen])

    useEffect(() => {
        getUnreadMsgCount()
    }, [])

    const getUnreadMsgCount = async () => {
        let orderUserType = (orderDetails.userType === "BUYER") ? 'SELLER' : 'BUYER'
        let url = `order/chat_unread/${orderDetails.id}/${orderUserType}`
        let response = await dispatch(getUnreadCountApi(url, token));
        if (response && typeof response === 'number' && response > 0) setUnreadMsgCount(response)
        else setUnreadMsgCount(0)
    }

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const scrollToBottom = () => {
        if (chatWindowRef.current) {
            chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
        }
    };

    useEffect(() => {
        if (openChatBoxState && !stompClient) {
            const socket = new SockJS(process.env.REACT_APP_API_URL + '/ws');
            const stomp = Stomp.over(socket);
            let username = orderDetails.userType === "BUYER" ? orderDetails?.buyerInfo?.companyName : orderDetails?.sellerInfo?.companyName
            stomp.connect({}, () => {
                setStompClient(stomp);
                stomp.subscribe(`/topic/chat/${orderDetails.id}`, onMessageReceived);
                stomp.send(`/app/chat/add/${orderDetails.id}`, {}, JSON.stringify({
                    type: 'JOIN',
                    orderId: orderDetails.id,
                    sender: username,
                    senderEmailId: localStorage.getItem('email'),
                    senderType: orderDetails.userType,
                    msg: null
                }));
                readAllMsgesFunction()
            });
            console.log = function () { };
            console.debug = function () { };
        }
        return () => {
            if (stompClient) {
                setStompClient(null)
                stompClient.disconnect();
            }
        };
    }, [openChatBoxState, orderDetails.id, stompClient]);

    const readAllMsgesFunction = async () => {
        let orderUserType = (orderDetails.userType === "BUYER") ? 'SELLER' : 'BUYER'
        let url = `order/read_all/${orderDetails.id}/${orderUserType}`
        await dispatch(msgReadAllApi(url, token));
        getUnreadMsgCount()
    }

    const onMessageReceived = (payload) => {
        const receivedMessage = JSON.parse(payload.body);
        setLoader(false);
        const { chatHistory, chatMessage } = receivedMessage || {};
        if (chatMessage?.type !== 'LEAVE') {
            setMessages(prevMessages => {
                let tempMsges = []
                if (chatMessage.type === 'CHAT') tempMsges = [...prevMessages];
                if (chatHistory) {
                    tempMsges = [...tempMsges, ...chatHistory.contents];
                }
                if (chatMessage && chatMessage.type === 'CHAT') {
                    tempMsges.push(chatMessage);
                }
                return tempMsges;
            });
            readAllMsgesFunction()
        }
        console.log = function () { };
        console.debug = function () { };
        // if (chatMessage && chatMessage.type === 'CHAT') {
        //     let readMessage = {
        //         senderType: chatMessage.senderType,
        //         id: chatMessage.id,
        //         orderId: chatMessage.orderId,
        //         type: 'CHAT'
        //     };
        //     stompClient.send(`/app/read/${orderDetails.id}`, {}, JSON.stringify(readMessage));
        // }
    };

    const sendMessage = (e) => {
        e.target.blur();
        if (stompClient && messageText.trim() !== '') {
            const chatMessage = {
                type: 'CHAT',
                orderId: orderDetails.id,
                sender: orderDetails.userType === "BUYER" ? orderDetails?.buyerInfo?.companyName : orderDetails?.sellerInfo?.companyName,
                senderEmailId: localStorage.getItem('email'),
                senderType: orderDetails.userType,
                msg: messageText.trim(),
            };
            stompClient.send(`/app/chat/${orderDetails.id}`, {}, JSON.stringify(chatMessage));
            setMessageText('');
        }
        console.log = function () { };
        console.debug = function () { };
    };

    const getLocalTime = (utcTime) => {
        const utcMoment = moment.utc(utcTime);
        const localTime = utcMoment.local();
        return localTime.format('MMM Do, YYYY, HH:mm');
    }

    const chatShortView = () => {
        const index = chatBottomStackedOrders.findIndex(id => id === orderDetails?.id);
        if (index !== -1) {
            return {
                right: `${index * 360}px`,
            }
        } else {
            return {}
        }

    }

    return (
        <div onClick={e => e.stopPropagation()}>
            <span className='blueBg' onClick={(e) => {
                e.stopPropagation();
                if (!isAccordionOpen) {
                    if (screenSize > 1200 && chatBottomStackedOrders?.length < 3) {
                        setOpenChatBoxState(true)
                        props.setChatBottomStackedOrders('add', orderDetails?.id)
                    } else if (screenSize < 1200) {
                        setOpenChatBoxState(true)
                        props.setChatBottomStackedOrders('removeAll')
                        props.setChatBottomStackedOrders('add', orderDetails?.id)
                    }
                } else {
                    setOpenChatBoxState(true)
                    props.setChatBottomStackedOrders('subtract', orderDetails?.id)
                }

            }}>
                {orderDetails?.userType === "BUYER" ? "Contact Seller" : "Contact Buyer"}{unreadMsgCount > 0 && <span>{unreadMsgCount}</span>}
            </span>

            {((isAccordionOpen && openChatBoxState) || (!isAccordionOpen && openChatBoxState && chatBottomStackedOrders?.includes(orderDetails?.id))) &&
                <div style={!isAccordionOpen ? chatShortView() : {}} className={isAccordionOpen ? "chat-popup" : "chat-popup-short-view"}>
                    <div className="form-container">
                        <div className="header">
                            <div>
                                <p style={{ fontSize: '18px', marginBottom: !isAccordionOpen ? '0px' : '8px' }}>{orderDetails?.userType === 'BUYER' ? 'Chat with seller' : 'Chat with buyer'}</p>
                                {!isAccordionOpen && <span style={{ color: '#fff', fontSize: '13px' }}>{`(${orderDetails?.orderDetails?.title})`}</span>}
                            </div>
                            <button type="button" className="btn cancel" onClick={(e) => {
                                e.stopPropagation();
                                setOpenChatBoxState(false)
                                setLoader(true)
                                setMessages([])
                                if (!isAccordionOpen) props.setChatBottomStackedOrders('subtract', orderDetails?.id)
                            }}>
                                <img src={CloseIconWhite} alt='close-icon' />
                            </button>
                        </div>

                        {(loader) && (
                            <div className="loader-overlay">
                                <div className="loader-text"></div>
                            </div>
                        )}

                        {(!loader && messages?.length === 0) && (
                            <div className={isAccordionOpen ? 'chat-initiate-style' : 'chat-initiate-style chat-initiate-style-short-view'}>
                                {`Initiate conversation with your ${orderDetails?.userType === 'BUYER' ? 'seller' : 'buyer'} regarding any inquiries regarding this order.`}
                            </div>
                        )}

                        <div className={isAccordionOpen ? 'chat-window' : 'chat-window chat-window-short-view'} ref={chatWindowRef}>
                            {messages?.map((message, index) => (
                                <div key={index} className={message.senderType === orderDetails?.userType ? 'chat-listing-user' : 'chat-listing-admin'}>
                                    <div className={message.senderType === 'BUYER' ? 'sender-initial sender-initial-buyer' : 'sender-initial sender-initial-seller'}>{message.senderType === 'BUYER' ? 'B' : 'S'}</div>
                                    <div style={{ marginBottom: '10px' }}>
                                        <div className={message.senderType === 'BUYER' ? 'chat-container darker' : 'chat-container'}>
                                            <p style={{ margin: '1px 0px 3px 0', wordBreak: 'break-all' }}>{message.msg}</p>
                                        </div>
                                        {message.date &&
                                            <span class={message.date === 'Buyer' ? "time-right" : "time-left"}>
                                                {getLocalTime(message.date)}
                                            </span>
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className={`footer ${loader && 'overlay-style'}`}>
                            <textarea placeholder="Please Type Message" name="msg" required value={messageText}
                                onChange={e => setMessageText(e.target.value)}
                                onKeyUp={e => e.key === 'Enter' && sendMessage(e)}></textarea>
                            <div className="btn enter-btn" onClick={sendMessage}>
                                <img src={ChatSendIcon} alt="image" />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default ChatBlock;
